import { IFilterProto } from '@monorepo/controlled/src/models/filter.model';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IMFPPStore } from '../../stores';
import { ITableFiltersActions, TableFilters } from '@monorepo/base/src/components/table/table-filters/table-filters';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { myLinksFilterPrototypes } from '../../components/filters';

interface IMyLinksActions {
	availableFilters?: IFilterProto[];
}

export const useMyLinksActions = (props: IMyLinksActions = {}) => {
	const { availableFilters } = props;
	const { settingsStore } = useStores<IMFPPStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();

	const filterStore = settingsStore
		.getPages()
		.get(currentRouteWithoutSpecialChars)
		?.tableStore.getFiltersStore(currentRouteWithoutSpecialChars);
	const currentFilters = filterStore?.getCurrentFilters();

	const DefaultAvailableFilters = [...myLinksFilterPrototypes];

	const FiltersActions = (tableFiltersProps: ITableFiltersActions) => {
		if (!currentFilters) {
			return null;
		}

		return (
			<TableFilters
				{...tableFiltersProps}
				availableFilters={availableFilters || DefaultAvailableFilters}
				currentFilters={currentFilters}
				clearAll={() => filterStore?.clearAll()}
				clearFilter={index => filterStore?.clearFilter(index)}
				addFilter={filter => filterStore?.addFilter(filter)}
				editFilter={(index, filter) => filterStore?.editFilter(index, filter)}
			/>
		);
	};

	return {
		FiltersActions,
	};
};
